import { render, staticRenderFns } from "./MakeupCapacity.vue?vue&type=template&id=5d0b7394&scoped=true"
import script from "./MakeupCapacity.vue?vue&type=script&lang=js"
export * from "./MakeupCapacity.vue?vue&type=script&lang=js"
import style0 from "./MakeupCapacity.vue?vue&type=style&index=0&id=5d0b7394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b7394",
  null
  
)

export default component.exports